import { useState } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { PoClosureSearchResult } from "models/po-closure";
import { useAuth } from "src/contexts/AuthContext";

export const usePoClosureSearch = () => {
  const [items, setItems] = useState<PoClosureSearchResult[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const searchOpenPos = async (params: { poNumber?: string; vendorName?: string }) => {
    const poNumber = (params.poNumber || "").trim();
    const vendorName = (params.vendorName || "").trim();
    if (!poNumber && !vendorName) {
      setError("Provide PO number or vendor name.");
      setItems([]);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const query = new URLSearchParams();
      if (poNumber) query.append("poNumber", poNumber);
      if (vendorName) query.append("vendorName", vendorName);
      query.append("limit", "50");

      const response = await fetchWithReauth(
        `${API_URL}/po-closures/search?${query.toString()}`,
      );
      const data = await checkResponse(response);
      setItems((data.items || []) as PoClosureSearchResult[]);
    } catch (searchError) {
      console.error("Error searching open POs:", searchError);
      setError("Failed to search open purchase orders.");
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  return { items, loading, error, searchOpenPos };
};
